import React from "react";
import { PageShell, Section, Bullets } from "../components/PageShell";

const EMAIL = "info@miseone.eu";

export const Support = () => (
  <PageShell eyebrow="Help" title="Support" testId="support-page">
    <p>
      We are a small team building MiseOne alongside the chefs who use it every day. If
      something is unclear, broken, or slowing you down, we want to hear about it — and
      fix it quickly.
    </p>

    <Section heading="How to contact us">
      <p>
        Write to{" "}
        <a href={`mailto:${EMAIL}`} className="text-[#EA6A43] underline-offset-4 hover:underline">
          {EMAIL}
        </a>
        . One inbox, one door. A real person will read your message.
      </p>
      <p>
        When you write, it helps if you can share:
      </p>
      <Bullets
        items={[
          "The name of your restaurant and your role.",
          "A short description of what you were trying to do.",
          "A screenshot or short video, if it is a visual issue.",
        ]}
      />
    </Section>

    <Section heading="What support covers">
      <Bullets
        items={[
          "Product questions — how a feature works, how to set something up.",
          "Onboarding help — getting your team, menu and inventory set up correctly.",
          "Bug reports — anything that is not behaving the way it should.",
          "Feature requests — tell us what would make your day easier.",
          "Account and billing questions.",
        ]}
      />
    </Section>

    <Section heading="Response time">
      <p>
        We reply within one business day (Monday to Friday, Helsinki time). Most
        questions are answered the same day.
      </p>
      <p>
        If your kitchen is blocked and you need urgent help, mark your email with the
        word <span className="font-semibold text-[#1b1a18]">Urgent</span> in the subject
        line and we will prioritise it.
      </p>
    </Section>

    <Section heading="Not sure where to start?">
      <p>
        If you have not seen the product yet, the fastest way to get answers is to book a
        short demo. We will walk you through the parts that are relevant to your
        kitchen.
      </p>
    </Section>
  </PageShell>
);

export default Support;
